import React from 'react';

/**
 * Top up WITHOUT losing the read: each pack posts to a Stripe Checkout Session (checkout.credit_pack,
 * so Stripe automatic tax applies) and Stripe returns to `resume` — paid or cancelled — so the sheet
 * can be opened again with the new balance. Replaced the injected checkout.js buttons on 2026-09-28:
 * they paid through a bare Stripe Charge, which cannot carry tax.
 */
export default function TopUp({ topup, resume, heading = 'Top up without leaving the read:' }) {
  const csrf = (typeof document !== 'undefined'
    && document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')) || '';
  const back = resume || (typeof location !== 'undefined' ? location.href : '');
  // Smallest pack first: the packs are a comparison, so they sit in equal cards on one row.
  const packs = [...topup.packs].sort((a, b) => a.credits - b.credits);
  return (
    <div className="tr-topup">
      <p className="tr-topuph">{heading}</p>
      <div className="tr-packs">
        {packs.map((p) => (
          <form key={p.credits} action={topup.checkout_url} method="POST" className="tr-pack">
            <input type="hidden" name="_token" value={csrf} />
            <input type="hidden" name="pack" value={p.credits} />
            <input type="hidden" name="return_to" value={back} />
            <span className="tr-packn">{p.credits} credits</span>
            <span className="tr-packp">{p.label}</span>
            {p.vat && <span className="tr-packvat">{p.vat}</span>}
            <button className="tr-btn tr-packbuy" type="submit" aria-label={`Buy ${p.credits} credits for ${p.label}`}>Buy</button>
          </form>
        ))}
      </div>
      {topup.note && <p className="tr-packnote">{topup.note}</p>}
    </div>
  );
}

/* Shared by the player's unlock sheet and the start dialog (which has no player stylesheet). */
export const TOPUP_CSS = `
.tr-topup{margin-top:16px;border-top:1px solid #e3edf1;padding-top:14px}
.tr-topuph{font-size:.9rem;font-weight:650;color:#102d38;margin:0 0 10px}
.tr-packs{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px}
.tr-pack{display:flex;flex-direction:column;align-items:stretch;text-align:center;gap:2px;border:1px solid #cfdde4;border-radius:10px;padding:12px}
.tr-packn{font-size:.9rem;font-weight:650;color:#102d38}
.tr-packp{font-size:1.2rem;font-weight:700;color:#14536e}
.tr-packvat{font-size:.78rem;color:#46657a}
.tr-packbuy{margin-top:8px;width:100%}
.tr-packnote{font-size:.82rem;line-height:1.45;color:#46657a;margin:8px 0 0}
`;
